import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mayuculaEspacios'
})
export class MayusculaEspaciosPipe implements PipeTransform {


  transform(texto: string): string | number {
    if (!texto) return '...'
    let separado = texto;  
    texto.split('').filter(element => element === '_').map( res =>{
    separado = separado.replace("_", " ");
    })
    let ultimo = separado.replace(separado.charAt(0),separado.charAt(0).toUpperCase()); 
    return ultimo
    
  } 
}